<template>
  <v-dialog
    v-model="modal"
    :width="width"
    :max-width="maxWidth"
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
  >
    <slot name="outer-body">
      <v-card>
        <v-card-title class="justify-space-between">
          <span :class="titleClass">{{ title }}</span>
          <slot name="header-right"></slot>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <slot name="inner-body">
            <v-container>
              <v-row>
                <v-col cols="12">
                  SLOT
                </v-col>
              </v-row>
            </v-container>
          </slot>
        </v-card-text>
      </v-card>
    </slot>
  </v-dialog>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Title'
    },
    customTitleClass: {
      type: String,
      default: ''
    },
    width: {
      default: ''
    },
    maxWidth: {
      default: '500px'
    }
  },
  watch: {
    modal(value) {
      this.$emit('modalStatus', value);
    }
  },
  computed: {
    titleClass() {
      return this.customTitleClass ? this.customTitleClass : this.$vuetify.breakpoint.xs ? 'title' : 'headline';
    }
  }
}
</script>

<style>

</style>